import React from 'react';
import Layout from '../components/Layout';
import CompanyList from '../components/CompanyList';
import useAutoTranslate from '../hooks/useAutoTranslate';
import { 
  Title,
  Card,
  CardHeader,
  Breadcrumbs,
  BreadcrumbsItem,
  Avatar,
  Icon
} from '@ui5/webcomponents-react';

/**
 * Página de listado de camiones
 * Utiliza el componente Layout para mantener la estructura consistente
 * y el componente CompanyList para mostrar la lista de compañías
 */
const Company = () => {
  const { autoT } = useAutoTranslate();
  return (
    <Layout>
      <div>
                <Card style={{ marginBottom: '1.5rem' }}>
          <CardHeader
            titleText={autoT('Gestión de Mandantes')}
            subtitleText={autoT('Administra y gestiona mandantes')}
            avatar={
              <Avatar 
                style={{ 
                  backgroundColor: 'var(--sapAccentColor6)',
                  color: 'white'
                }}
              >
                <Icon name="supplier" />
              </Avatar>
            }
          />
        </Card>
        <CompanyList />
      </div>
    </Layout>
  );
};

export default Company;